(function() {
  var ParentHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ParentHandler = App.loadClass('portal::handlers/convert/Parent_Handler');

  exports.Delivery_Handler = (function(superClass) {
    extend(Delivery_Handler, superClass);

    function Delivery_Handler() {
      return Delivery_Handler.__super__.constructor.apply(this, arguments);
    }

    Delivery_Handler.prototype.init = function() {
      this.subHandler = 'portal::handlers/convert/Delivery_Dialog_Handler';
      this.filters = 'backend/portal/delivery/get-filter-data';
      return Delivery_Handler.__super__.init.call(this);
    };

    return Delivery_Handler;

  })(ParentHandler);

}).call(this);
